/**
 * FERP Portal - Policy List Page (DRR-074: Tabulator DRY Template)
 *
 * DESIGN Phase: Zen Engine policy rules driving data-driven architecture.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function PolicyListPage() {
  return <TabulatorPrimitiveManager primitiveType="policy" />;
}

export default PolicyListPage;
